import { FullName, IParty } from '../../ui-toolkit/orders/interfaces/IParty';

export const getPartyFullNames = (parties: IParty[]): string => parties.map(FullName).join(' and ');

export default getPartyFullNames;
